import loadable from '@loadable/component';

export const EmbedSearchWidgetViewImportedVolopPageLoadable = loadable(
  () => import('./EmbedSearchWidgetViewImportedVolopPage'),
  {
    resolveComponent: (module) => module.EmbedSearchWidgetViewImportedVolopPage,
  },
);
